interface SourcePlayback {
  kind?: 'file' | 'hls'
  scope?: 'recording' | 'preview-window'
  timeline_available?: boolean
}

/** Older HLS responses also carry a window clock without a source offset. */
export function isPreviewWindow(playback: SourcePlayback | null | undefined): boolean {
  return Boolean(playback && (playback.scope === 'preview-window'
    || (playback.kind === 'hls' && playback.scope !== 'recording')))
}

export function sourceTimelineAvailable(playback: SourcePlayback | null | undefined): boolean {
  return Boolean(playback && playback.timeline_available !== false
    && (!isPreviewWindow(playback) || playback.timeline_available === true))
}
